export const getSubdomain = () => {
  const hostname = window.location.hostname;

  console.log("hostname:", hostname);

  // localhost support
  if (hostname.includes("localhost")) {
    const parts = hostname.split(".");

    // demo.localhost
    if (parts.length > 1) {
      return parts[0];
    }

    return "demo";
  }

  const parts = hostname.split(".");

  console.log("parts:", parts);

  // subdomain.domain.com
  if (parts.length >= 3) {
    return parts[0];
  }

  return "demo";
};

export const capitalizeFirstLetter = (str?: string): string => {
  if (!str) return "-";
  return str.charAt(0).toUpperCase() + str.slice(1);
};